import moment from "moment";

export const checkPlanningsOverlap = (plannings, slotInfo, targetPlanning) => {
  const { start, end } = slotInfo;
  const startTime = start.getTime();
  const endTime = end.getTime();
  // Prevent planning from spanning over several days
  if (start.getDay() !== end.getDay()) {
    return false;
  }

  return (
    plannings
      .filter((planning) =>
        targetPlanning ? targetPlanning.id !== planning.id : true
      )
      .findIndex((planning) => {
        const startTime2 = planning.start.getTime();
        const endTime2 = planning.end.getTime();
        return (
          (startTime >= startTime2 && startTime < endTime2) ||
          (startTime2 >= startTime && startTime2 < endTime)
        );
      }) === -1
  );
};

// Hack to display a single week in react calendar
// The week is based on the first week of 2018, because the first day is monday 1st
export const createCalendarDates = (planning) => {
  const day = planning.dayOfWeek === 0 ? 7 : planning.dayOfWeek;
  const start = moment({
    y: 2018,
    M: 0,
    d: day,
    h: planning.hourStart,
  }).toDate();
  let end;
  if (planning.hourEnd === 23) {
    // planning.hourEnd === 24
    end = moment({
      y: 2018,
      M: 0,
      d: day,
      h: 23,
      //h: 20,
      m: 0,
    }).toDate();
  } else {
    end = moment({
      y: 2018,
      M: 0,
      d: day,
      h: planning.hourEnd,
    }).toDate();
  }
  console.log("end", end);
  return {
    start,
    end,
  };
};



// WEBPACK FOOTER //
// ./src/pages/plannings/planningUtils.js